import { Formik, Form } from 'formik'

import { ModalWrapper } from 'src/components/modal-wrapper'
import { PriceForm } from './form.component'
import { ISubscriptionPriceForm } from 'src/types'
import { subscriptionPriceSchema } from 'src/common/validations'

import { useStyles } from '../../styles'
import { useUpdateSubscriptionPrices } from 'src/hooks/subscription-prices/use-update-subscription-price.hook'

interface IProps {
  open: boolean
  handleClose: () => void
  id: string
  initial: ISubscriptionPriceForm
}

export const UpdateSubscriptionForm = ({ open, handleClose, id, initial }: IProps) => {
  const classes = useStyles()
  const { mutateAsync } = useUpdateSubscriptionPrices()

  const handleSubmit = async (values: ISubscriptionPriceForm) => {
    const resp = await mutateAsync({ ...values, id })
    if (!resp) return

    handleClose()
  }

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <Formik
        initialValues={initial}
        validationSchema={subscriptionPriceSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <PriceForm />
        </Form>
      </Formik>
    </ModalWrapper>
  )
}
